export function getTokenStorageKey(subdomain: string) {
  return `token${subdomain}`;
}

export function getVaultViewStorageKey(subdomain: string) {
  return `vaultView${subdomain}`;
}

export function getCreatorOnboardingHiddenStorageKey(subdomain: string) {
  return `creatorOnboardingHidden${subdomain}`;
}

function getFunnelRedirectCookieName(subdomain: string) {
  return `fanvault_funnel_redirect_${encodeURIComponent(subdomain || "default")}`;
}

export function loadToken(subdomain: string) {
  return window.localStorage.getItem(getTokenStorageKey(subdomain)) ?? "";
}

export function saveToken(subdomain: string, token: string) {
  window.localStorage.setItem(getTokenStorageKey(subdomain), token);
}

export function clearToken(subdomain: string) {
  window.localStorage.removeItem(getTokenStorageKey(subdomain));
}

export function loadVaultView(subdomain: string) {
  return window.localStorage.getItem(getVaultViewStorageKey(subdomain)) ?? "creator";
}

export function saveVaultView(subdomain: string, view: "creator" | "user") {
  window.localStorage.setItem(getVaultViewStorageKey(subdomain), view);
}

export function clearVaultView(subdomain: string) {
  window.localStorage.removeItem(getVaultViewStorageKey(subdomain));
}

export function loadCreatorOnboardingHidden(subdomain: string) {
  return window.localStorage.getItem(getCreatorOnboardingHiddenStorageKey(subdomain)) === "1";
}

export function saveCreatorOnboardingHidden(subdomain: string) {
  window.localStorage.setItem(getCreatorOnboardingHiddenStorageKey(subdomain), "1");
}

export function clearCreatorOnboardingHidden(subdomain: string) {
  window.localStorage.removeItem(getCreatorOnboardingHiddenStorageKey(subdomain));
}

export function saveFunnelRedirect(subdomain: string, path: string) {
  if (!subdomain || !path.startsWith("/") || /^\/(?:login|register)(?:\/|$)/.test(path)) {
    return;
  }

  const expiresInSeconds = 60 * 60 * 24 * 14;
  document.cookie = `${getFunnelRedirectCookieName(subdomain)}=${encodeURIComponent(path)}; Max-Age=${expiresInSeconds}; Path=/; SameSite=Lax`;
}

export function loadFunnelRedirect(subdomain: string) {
  if (!subdomain) {
    return "";
  }

  const cookieName = `${getFunnelRedirectCookieName(subdomain)}=`;
  const cookie = document.cookie
    .split(";")
    .map((value) => value.trim())
    .find((value) => value.startsWith(cookieName));

  return cookie ? decodeURIComponent(cookie.slice(cookieName.length)) : "";
}

export function clearFunnelRedirect(subdomain: string) {
  if (!subdomain) {
    return;
  }

  document.cookie = `${getFunnelRedirectCookieName(subdomain)}=; Max-Age=0; Path=/; SameSite=Lax`;
}
